define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll', 'jump',
        'underscore', 'lightbox', 'slider', 'load-more'],
    function ($, transit, modernizr, container, preloader, router, scroll, jumpFactory,
              _, lightboxFactory, sliderFactory, loadMoreFactory) {

        var module = (function () {

            var name = 'module-gallery-content';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            const jump = jumpFactory.create();
            const lightbox = lightboxFactory.create();
            let loadMore = loadMoreFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {
                loadedItems: new Map()
            };

            model.methods = {
                getGallery: function (slug) {
                    if(model.privateVars.loadedItems.has(slug)) {
                        pubSub.publish('view/actionShowGallery', model.privateVars.loadedItems.get(slug));
                    } else {
                        $.ajax({
                            url: model.publicVars.ajaxGetGalleryEndpoint + '/' + slug,
                            type: 'GET',
                            data: {}
                        }).done(function (data) {
                            model.privateVars.loadedItems.set(slug, data);
                            pubSub.publish('view/actionShowGallery', data);
                        });
                    }
                },

                getLightboxGalleryItems: function (id, slug) {
                    if(model.privateVars.loadedItems.has(slug)) {
                        let data = model.privateVars.loadedItems.get(slug);
                        data.selected_image_id = id;
                        pubSub.publish('view/actionGetLightboxItems', data);
                    } else {
                        $.ajax({
                            url: model.publicVars.ajaxGetGalleryEndpoint + '/' + slug,
                            type: 'GET',
                            data: {}
                        }).done(function (data) {
                            model.privateVars.loadedItems.set(slug, data);
                            data.selected_image_id = id;
                            pubSub.publish('view/actionGetLightboxItems', data);
                        });
                    }
                }
            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                anim: 0,
                lightboxAnim: 0,

                currentGallery: {
                    id: null,
                    slug: null
                },

                currentGalleryLightboxImages: {
                    items: {},
                    count: 0
                },

                currentGalleryLightboxImage: null,

                isSliderInit: false,
                loadingSliderItemsState: false,
                loadingSliderItemsNewId: null,

                gallerySize: {
                    width: 932,
                    height: 611
                },

                lightboxTouch: {
                    lightboxTouchStart: 0,
                    lightboxTouchDiff: 0,
                    lightboxTouchStartY: 0,
                    lightboxTouchDiffY: 0,

                    lightboxSlideStarted: false,
                    lightboxEndTrans: false,
                }
            };

            view.startup = function () {
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.galleryContentHeaderCls, 'animate__slideInDown', 'gallery-content', {});
                $(view.publicVars.cssId.anim.galleryContentBarWrapperCls).each(function (key, item) {
                    const id = container.getData($(item)[0], 'id');
                    scroll.registerAnimatedElement('#' + view.publicVars.cssId.anim.galleryContentBarWrapperCls.substr(1) + id, 'animate__fadeIn', 'gallery-content', {});
                });

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.galleryContentFilmBottomCls, 'animate__lightSpeedInLeft', 'gallery-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.galleryContentDetailsHeaderCls + view.publicVars.currentGallery.id , 'animate__fadeIn', 'gallery-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.galleryContentDetailsSubheaderCls + view.publicVars.currentGallery.id , 'animate__fadeIn', 'gallery-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.galleryContentDetailsDescCls + view.publicVars.currentGallery.id , 'animate__fadeIn', 'gallery-content', {});

                $(view.publicVars.cssId.anim.galleryContentGalleryImageBoxWrapperCls).each(function (key, item) {
                    const id = container.getData($(item)[0], 'id');
                    scroll.registerAnimatedElement('#' + view.publicVars.cssId.anim.galleryContentGalleryImageBoxWrapperCls .substr(1)
                        + view.publicVars.currentGallery.id + '-' + id, 'animate__zoomIn', 'gallery-content', {});
                });

                if($(view.publicVars.cssId.anim.galleryContentGalleryLoadMoreCls).length > 0) {
                    scroll.registerAnimatedElement(view.publicVars.cssId.anim.galleryContentGalleryLoadMoreCls, 'animate__zoomIn', 'gallery-content', {});
                }

                view.privateVars.currentGallery.id = view.publicVars.currentGallery.id;
                view.privateVars.currentGallery.slug = view.publicVars.currentGallery.slug;

                $(view.publicVars.cssId.galleryContentBarCls).each(function(key, item) {
                    $(item).removeAttr('href');
                });

                lightbox.init(view.publicVars.lightboxSetup);
                lightbox.setCloseCallback(view.methods.lightbox.onLightboxClose);

                preloader.setPreloadBulk(name, view.publicVars.preloadTab);

                loadMore.init(view.publicVars.loadMoreSetup);
                loadMore.setAdditionalParamCallback(view.methods.loadMore.getCurrentGallerySlug);
                loadMore.setSuccessCallback(view.methods.loadMore.loadMoreSuccessCallback);
            };

            view.bind = function () {
                $(view.publicVars.cssId.galleryContentBarCls).click(function () {
                    const id = container.getData($(this)[0], 'id');
                    const slug = container.getData($(this)[0], 'slug');
                    const metaTitle = container.getData($(this)[0], 'meta.title');

                    if(view.privateVars.anim === 0) {

                        if(view.privateVars.currentGallery.id === id) {
                            //view.methods.details.closeGalleries();
                        } else {
                            view.privateVars.anim = 1;
                            let currentScrollTop = false;

                            if(id > view.privateVars.currentGallery.id && view.privateVars.currentGallery.id !== null) {
                                currentScrollTop = $(window).scrollTop()
                                    - $('#' + view.publicVars.cssId.galleryContentDetailsCls.substr(1) + view.privateVars.currentGallery.id).outerHeight();
                            }

                            view.methods.details.closeGalleries();

                            view.methods.details.handleItemOpen(id, slug, metaTitle, currentScrollTop);
                        }
                    }
                });

                $(view.publicVars.cssId.galleryContentBarsCls).on('click', view.publicVars.cssId.galleryContentGalleryImageBoxWrapperCls,function () {

                    view.privateVars.lightboxAnim = 1;

                    const id = container.getData($(this)[0], 'id');
                    const width = container.getData($(this)[0], 'width');
                    const height = container.getData($(this)[0], 'height');

                    $('html').addClass(view.publicVars.cssId.galleryLightboxOpenCls.substr(1));
                    $(view.publicVars.cssId.galleryContentLightboxLoaderWrapperCls).css({ display: 'block'});
                    $(view.publicVars.cssId.galleryContentGalleryLightboxCls).addClass(view.publicVars.cssId.isLoadingCls.substr(1));

                    view.methods.lightbox.calculateLightboxSize(width, height);

                    lightbox.showLayer(() => {
                        scroll.disableAll();
                        view.methods.lightbox.sliderShowInit(id);
                    });
                });

                $(view.publicVars.cssId.galleryContentGalleryLightboxArrowLeftId).click(function () {
                    const newId = (view.privateVars.currentGalleryLightboxImage > 1)
                        ? (view.privateVars.currentGalleryLightboxImage - 1) : view.privateVars.currentGalleryLightboxImages.count;

                    if(!view.privateVars.lightboxAnim) {
                        view.privateVars.lightboxAnim = 1;
                        view.methods.lightbox.sliderShowInit(newId);
                    }
                });

                $(view.publicVars.cssId.galleryContentGalleryLightboxArrowRightId).click(function () {
                    const newId = (view.privateVars.currentGalleryLightboxImage < view.privateVars.currentGalleryLightboxImages.count)
                        ? (view.privateVars.currentGalleryLightboxImage + 1) : 1;

                    if(!view.privateVars.lightboxAnim) {
                        view.privateVars.lightboxAnim = 1;
                        view.methods.lightbox.sliderShowInit(newId);
                    }
                });

                $(window).resize(() => {
                    if (lightbox.getStatus() === 1) {

                        let currentImage = {
                            'width': view.privateVars.gallerySize.width,
                            'height': view.privateVars.gallerySize.height
                        }

                        if(view.privateVars.currentGalleryLightboxImage) {
                            currentImage = view.privateVars.currentGalleryLightboxImages.items[view.privateVars.currentGalleryLightboxImage];
                        }

                        view.methods.lightbox.calculateLightboxSize(currentImage.width, currentImage.height);
                    }
                });

                $(window).on('orientationchange', () => {
                    if (lightbox.getStatus() === 1) {
                        let currentImage = {
                            'width': view.privateVars.gallerySize.width,
                            'height': view.privateVars.gallerySize.height
                        }

                        if(view.privateVars.currentGalleryLightboxImage) {
                            currentImage = view.privateVars.currentGalleryLightboxImages.items[view.privateVars.currentGalleryLightboxImage];
                        }

                        view.methods.lightbox.calculateLightboxSize(currentImage.width, currentImage.height);
                    }
                });

                $(view.publicVars.cssId.galleryContentGalleryLightboxInnerId).bind('touchstart', function(e) {
                    //e.preventDefault();
                    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.lightbox.slideMouseDown(touch);
                });

                $(view.publicVars.cssId.galleryContentGalleryLightboxInnerId).bind('touchmove', function(e) {
                    /*if (Math.abs(privateVars.touchDiff) >= Math.abs(privateVars.touchDiffY)) {
                     e.preventDefault();
                     }*/
                    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.lightbox.slideMouseMove(touch, e);
                });

                $(view.publicVars.cssId.galleryContentGalleryLightboxInnerId).bind('touchend', function(e) {
                    //e.preventDefault();
                    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.lightbox.slideMouseUp(touch);
                });
            };

            view.methods = {

                loadMore: {
                    getCurrentGallerySlug: () => {
                        return view.privateVars.currentGallery.slug
                    },

                    loadMoreSuccessCallback: (data, newCount) => {
                        if(data.current && data.current.images.length > 0) {
                            data.current.images.forEach(function (item) {
                                scroll.registerAnimatedElement('#' + view.publicVars.cssId.anim.galleryContentGalleryImageBoxWrapperCls.substr(1)
                                    + data.current.id + '-' + item.id, 'animate__zoomIn', 'gallery-content', {});
                            });
                        }
                    }
                },

                details: {
                    closeGalleries: () => {

                        container.msg(name + ' - close galleries');

                        $(view.publicVars.cssId.galleryContentBarCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                        $(view.publicVars.cssId.galleryBarArrowCls).removeClass(view.publicVars.cssId.isUpCls.substr(1));

                        $(view.publicVars.cssId.galleryContentDetailsCls).css({ display: 'none', visibility: 'hidden', opacity: '0'});
                        $(view.publicVars.cssId.galleryContentDetailsInnerCls).css({ display: 'none', visibility: 'hidden', opacity: '0'});

                        scroll.unregisterAnimatedElement(view.publicVars.cssId.anim.galleryContentDetailsHeaderCls + view.privateVars.currentGallery.id);
                        scroll.unregisterAnimatedElement(view.publicVars.cssId.anim.galleryContentDetailsSubheaderCls + view.privateVars.currentGallery.id);
                        scroll.unregisterAnimatedElement(view.publicVars.cssId.anim.galleryContentDetailsDescCls + view.privateVars.currentGallery.id);

                        if($(view.publicVars.cssId.anim.galleryContentGalleryLoadMoreCls).length > 0) {
                            scroll.unregisterAnimatedElement(view.publicVars.cssId.anim.galleryContentGalleryLoadMoreCls);
                        }

                        $(view.publicVars.cssId.anim.galleryContentGalleryImageBoxWrapperCls).each(function (key, item) {
                            const id = container.getData($(item)[0], 'id');
                            scroll.unregisterAnimatedElement('#' + view.publicVars.cssId.anim.galleryContentGalleryImageBoxWrapperCls .substr(1)
                                + view.privateVars.currentGallery.id + '-' + id);
                        });

                        $(view.publicVars.cssId.galleryContentDetailsInnerCls).html('');
                    },

                    handleItemOpen: (id, slug, metaTitle, currentScrollTop) => {

                        if(currentScrollTop !== false) {
                            $(window).scrollTop(currentScrollTop);
                        }

                        view.privateVars.isSliderInit = false;
                        view.privateVars.loadingSliderItemsState = false;

                        view.privateVars.currentGalleryLightboxImages = {
                            items: {},
                            count: 0
                        };

                        view.privateVars.currentGalleryLightboxImage = null;
                        view.privateVars.lightboxAnim = 0;

                        view.privateVars.currentGallery.id = id;
                        view.privateVars.currentGallery.slug = slug;
                        router.route(view.publicVars.baseUrl + '/' + slug, metaTitle);

                        $('#' + view.publicVars.cssId.galleryContentBarCls.substr(1) + id).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                        $('#' + view.publicVars.cssId.galleryBarArrowCls.substr(1) + id).addClass(view.publicVars.cssId.isUpCls.substr(1));

                        $('#' + view.publicVars.cssId.galleryContentDetailsCls.substr(1) + id).css({ display: 'block', visibility: 'visible', opacity: '1'});

                        $('#' + view.publicVars.cssId.galleryContentDetailsCls.substr(1) + id).css({
                            height: 0
                        });

                        // $('html').css({ overflowY: 'scroll'});
                        $('#' + view.publicVars.cssId.galleryContentDetailsCls.substr(1) + id).transit({
                            height: '300px'
                        }, 300, () => {
                            $(view.publicVars.cssId.galleryContentDetailsLoaderWrapperId + id).css({ display: 'block', opacity: 0});

                            $(view.publicVars.cssId.galleryContentDetailsLoaderWrapperId + id).transit({ opacity: 1 });

                            jump.centerTo(view.publicVars.cssId.galleryContentDetailsLoaderWrapperId + id, () => {
                                model.methods.getGallery(slug);
                            });
                        });
                    },

                    actionShowGallery: (action, data) => {

                        const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();

                        let images = [];

                        if(data.current && data.current.images) {
                            for(let i = 0; i < data.current.images.length; i++) {
                                images.push(data.current.images[i].box);
                                images.push(data.current.images[i].big);
                            }
                        }

                        const compiled = _.template($(view.publicVars.cssId.templateId).html());

                        const output = compiled({
                            data: data
                        });

                        preloader.setPreloadBulk('gallery-' + data.current.id, images);

                        preloader.getPreloadBulkFinished('gallery-' + data.current.id, function () {
                            $('#' + view.publicVars.cssId.galleryContentDetailsInnerCls.substr(1) + data.current.id).html(output);

                            // $(view.publicVars.cssId.galleryContentDetailsLoaderWrapperId + data.current.id).transit({ opacity: 0 }, 0, () => {
                            $(view.publicVars.cssId.galleryContentDetailsLoaderWrapperId + data.current.id).removeAttr('style');
                            // });

                            const modifier = - parseInt((headerHeight));

                            jump.jumpTo('#' + view.publicVars.cssId.galleryContentBarCls.substr(1) + data.current.id, { modifier: modifier + 'px', speed: 300 });

                            $('#' + view.publicVars.cssId.galleryContentDetailsCls.substr(1) + data.current.id).removeAttr('style');
                            $('#' + view.publicVars.cssId.galleryContentDetailsCls.substr(1) + data.current.id).css({ visibility: 'visible', display: 'block'});

                            $('#' + view.publicVars.cssId.galleryContentDetailsInnerCls.substr(1) + data.current.id).removeAttr('style');

                            $('#' + view.publicVars.cssId.galleryContentDetailsInnerCls.substr(1) + data.current.id).css({ opacity: 0 });

                            $(view.publicVars.cssId.anim.galleryContentDetailsHeaderCls + data.current.id).animateCss('animate__fadeIn', () => {
                                $(view.publicVars.cssId.anim.galleryContentDetailsHeaderCls + data.current.id).addClass('animate__animated animate__fadeIn');
                            });
                            $(view.publicVars.cssId.anim.galleryContentDetailsSubheaderCls + data.current.id).animateCss('animate__fadeIn', () => {
                                $(view.publicVars.cssId.anim.galleryContentDetailsSubheaderCls + data.current.id).addClass('animate__animated animate__fadeIn');
                            });
                            $(view.publicVars.cssId.anim.galleryContentDetailsDescCls + data.current.id).animateCss('animate__fadeIn', () => {
                                $(view.publicVars.cssId.anim.galleryContentDetailsDescCls + data.current.id).addClass('animate__animated animate__fadeIn');
                            });

                            $(view.publicVars.cssId.anim.galleryContentGalleryImageBoxWrapperCls).each(function (key, item) {
                                const id = container.getData($(item)[0], 'id');

                                $('#' + view.publicVars.cssId.anim.galleryContentGalleryImageBoxWrapperCls .substr(1)
                                    + data.current.id + '-' + id).animateCss('animate__zoomIn', () => {
                                    $('#' + view.publicVars.cssId.anim.galleryContentGalleryImageBoxWrapperCls .substr(1)
                                        + data.current.id + '-' + id).addClass('animate__animated animate__zoomIn');
                                });

                                scroll.registerAnimatedElement('#' + view.publicVars.cssId.anim.galleryContentGalleryImageBoxWrapperCls .substr(1)
                                    + data.current.id + '-' + id, 'animate__zoomIn', 'gallery-content', {});
                            });

                            scroll.registerAnimatedElement(view.publicVars.cssId.anim.galleryContentDetailsHeaderCls + data.current.id , 'animate__fadeIn', 'gallery-content', {});
                            scroll.registerAnimatedElement(view.publicVars.cssId.anim.galleryContentDetailsSubheaderCls + data.current.id , 'animate__fadeIn', 'gallery-content', {});
                            scroll.registerAnimatedElement(view.publicVars.cssId.anim.galleryContentDetailsDescCls + data.current.id , 'animate__fadeIn', 'gallery-content', {});

                            if($(view.publicVars.cssId.anim.galleryContentGalleryLoadMoreCls).length > 0) {
                                scroll.registerAnimatedElement(view.publicVars.cssId.anim.galleryContentGalleryLoadMoreCls, 'animate__zoomIn', 'gallery-content', {});

                                let loadMore = loadMoreFactory.create();

                                view.publicVars.loadMoreSetup.itemsCount = data.count_all;
                                view.publicVars.loadMoreSetup.itemsLimit = data.init_limit;

                                loadMore.init(view.publicVars.loadMoreSetup);
                                loadMore.setAdditionalParamCallback(view.methods.loadMore.getCurrentGallerySlug);
                                loadMore.setSuccessCallback(view.methods.loadMore.loadMoreSuccessCallback);
                            }

                            $('#' + view.publicVars.cssId.galleryContentDetailsInnerCls.substr(1) + data.current.id).transit({ opacity: 1}, 300, () => {
                            });

                            view.privateVars.anim = 0;
                        });

                    },
                },

                lightbox: {
                    sliderShowInit: (id) => {

                        //$(view.publicVars.cssId.galleryLightboxSlideCls + id).css({ display: 'block'});

                        if(!view.privateVars.loadingSliderItemsState) {

                            view.privateVars.loadingSliderItemsNewId = null;

                            if (!view.privateVars.isSliderInit) {
                                view.privateVars.isSliderInit = true;
                                view.privateVars.loadingSliderItemsState = true;
                                // view.methods.lightbox.actionGetLightboxItems(id);
                                model.methods.getLightboxGalleryItems(id, view.privateVars.currentGallery.slug);
                            } else {

                                view.methods.lightbox.sliderShow(id);
                            }
                        } else {
                            view.privateVars.loadingSliderItemsNewId = id;
                        }

                    },

                    actionGetLightboxItems: (action, data) => {

                        let id = data.selected_image_id;

                        view.privateVars.loadingSliderItemsState = false;

                        if(view.privateVars.loadingSliderItemsNewId !== null) {
                            id = parseInt(view.privateVars.loadingSliderItemsNewId);
                            view.privateVars.loadingSliderItemsNewId = null;
                        }

                        data.current.images_all.forEach(function (item) {

                            view.privateVars.currentGalleryLightboxImages.items[item.id] = {
                                image: item.big,
                                id: item.id,
                                title: data.current.header.replace(/\"/g, ''),
                                width: item.width,
                                height: item.height
                            }

                        });

                        view.privateVars.currentGalleryLightboxImages.count = data.current.count_all;

                        view.methods.lightbox.sliderShow(id);
                    },

                    sliderShow: (id) => {

                        let currentImage = view.privateVars.currentGalleryLightboxImages.items[id];
                        view.privateVars.currentGalleryLightboxImage = parseInt(id);

                        const lightboxSize = view.methods.lightbox.calculateLightboxSize(currentImage.width, currentImage.height);

                        $(view.publicVars.cssId.galleryContentLightboxInnerAreaImgCls).css({ display: 'block', opacity: 0, scale: 1});

                        preloader.preloadSingleImage('slider-init', currentImage.image, () => {

                            $(view.publicVars.cssId.galleryContentLightboxInnerAreaImgCls).attr('src', currentImage.image);

                            setTimeout(function () {
                                $(view.publicVars.cssId.galleryContentGalleryLightboxCls).removeClass(view.publicVars.cssId.isLoadingCls.substr(1));

                                $(view.publicVars.cssId.galleryContentLightboxInnerAreaImgCls).transit({ opacity: 1, scale: 1}, 300, function () {
                                    view.privateVars.lightboxAnim = 0;
                                });
                            }, 500)


                        });
                    },

                    calculateLightboxSize: (width, height) => {

                        const windowWidth = $(window).width();
                        const windowHeight = $(window).height();

                        const paddingTop = parseInt($(view.publicVars.cssId.galleryContentGalleryLightboxAreaCls).css('padding-top'));
                        const paddingBottom = parseInt($(view.publicVars.cssId.galleryContentGalleryLightboxAreaCls).css('padding-bottom'));
                        const paddingLeft = parseInt($(view.publicVars.cssId.galleryContentGalleryLightboxAreaCls).css('padding-left'));
                        const paddingRight = parseInt($(view.publicVars.cssId.galleryContentGalleryLightboxAreaCls).css('padding-right'));

                        const border = parseInt($(view.publicVars.cssId.galleryContentGalleryLightboxAreaCls).css('border-width'));

                        const maxWidth = windowWidth - paddingLeft - paddingRight - border - border;
                        const maxHeight = windowHeight - paddingTop - paddingBottom - border - border;

                        // const maxWidth = windowWidth;
                        // const maxHeight = windowHeight;

                        let lightboxSize;

                        let adjustedWidth = view.privateVars.gallerySize.width;
                        let adjustedHeight = view.privateVars.gallerySize.height;

                        if (width !== '' && height !== '' && parseInt(width) > 400 && parseInt(height) > 400) {
                            adjustedWidth = parseInt(width);
                            adjustedHeight = parseInt(height);
                        }

                        //adjustedWidth = adjustedWidth + paddingLeft + paddingRight;
                        //adjustedHeight = adjustedHeight + paddingTop + paddingBottom;

                        lightboxSize = view.methods.lightbox.calculateSizeProportionForMaxValues(maxWidth, maxHeight,
                            adjustedWidth, adjustedHeight);

                        const newWidth = lightboxSize.width + paddingLeft + paddingRight + border + border;
                        const newHeight = lightboxSize.height + paddingTop + paddingBottom + border + border;

                        $(view.publicVars.cssId.galleryContentGalleryLightboxAreaCls)
                            .css({width: newWidth + 'px', height: newHeight + 'px'});

                    },

                    calculateSizeProportionForMaxValues: (maxWidth, maxHeight, width, height) => {

                        if (width <= maxWidth && height <= maxHeight) {
                            return {width: width, height: height};
                        }

                        const widthHeightRatio = width / height;
                        const heightWidthRatio = height / width;

                        if (width > maxWidth) {

                            const widthDiff = width - maxWidth;
                            width = maxWidth;
                            height = height - (heightWidthRatio * widthDiff);
                        }

                        if (height > maxHeight) {
                            const heightDiff = height - maxHeight;
                            height = maxHeight;

                            width = width - (widthHeightRatio * heightDiff);
                        }

                        return {width: width, height: height};
                    },

                    onLightboxClose: () => {
                        scroll.enableAll();
                        $('html').removeClass(view.publicVars.cssId.galleryLightboxOpenCls.substr(1));
                        $(view.publicVars.cssId.galleryContentGalleryLightboxCls).addClass(view.publicVars.cssId.isLoadingCls.substr(1));
                        $(view.publicVars.cssId.galleryContentLightboxLoaderWrapperCls).css({ display: 'block'});

                        $(view.publicVars.cssId.galleryContentLightboxInnerAreaImgCls).css({ display: 'none'});

                        view.privateVars.currentGalleryLightboxImage = null;
                    },

                    slideMouseDown: function(e) {

                        if (!view.privateVars.lightboxTouch.lightboxSlideStarted && view.privateVars.lightboxAnim === 0)
                        {
                            view.privateVars.lightboxTouch.lightboxTouchStart = e.pageX;
                            view.privateVars.lightboxTouch.lightboxTouchStartY = e.pageY;

                            view.privateVars.lightboxTouch.lightboxSlideStarted = true;
                        }

                        //return false;

                    },

                    slideMouseMove: function(e, ev) {

                        if (view.privateVars.lightboxTouch.lightboxSlideStarted && !view.privateVars.lightboxTouch.lightboxEndTrans
                            && view.privateVars.lightboxAnim === 0)
                        {
                            view.privateVars.lightboxTouch.lightboxTouchDiff = view.privateVars.lightboxTouch.lightboxTouchStart - e.pageX;
                            view.privateVars.lightboxTouch.lightboxTouchDiffY = view.privateVars.lightboxTouch.lightboxTouchStartY - e.pageY;

                            if (view.privateVars.lightboxTouch.lightboxTouchDiff < -40) {
                                view.privateVars.lightboxAnim = 1;

                                const newId = (view.privateVars.currentGalleryLightboxImage > 1)
                                    ? (view.privateVars.currentGalleryLightboxImage - 1) : view.privateVars.currentGalleryLightboxImages.count;

                                view.methods.lightbox.sliderShow(newId);
                            } else if (view.privateVars.lightboxTouch.lightboxTouchDiff > 40) {
                                view.privateVars.lightboxAnim = 1;

                                const newId = (view.privateVars.currentGalleryLightboxImage < view.privateVars.currentGalleryLightboxImages.count)
                                    ? (view.privateVars.currentGalleryLightboxImage + 1) : 1;

                                view.methods.lightbox.sliderShow(newId);
                            }

                            if (Math.abs(view.privateVars.lightboxTouch.lightboxTouchDiff) >= Math.abs(view.privateVars.lightboxTouch.lightboxTouchDiffY)) {
                                ev.preventDefault();
                            }
                        }

                        //return false;
                    },

                    slideMouseUp: function(e) {

                        if (view.privateVars.lightboxTouch.lightboxSlideStarted && view.privateVars.lightboxAnim === 0)
                        {
                            view.privateVars.lightboxTouch.lightboxEndTrans = true;
                            if (view.privateVars.lightboxTouch.lightboxTouchDiff < -40) {
                                view.privateVars.lightboxAnim = 1;

                                const newId = (view.privateVars.currentGalleryLightboxImage > 1)
                                    ? (view.privateVars.currentGalleryLightboxImage - 1) : view.privateVars.currentGalleryLightboxImages.count;

                                view.methods.lightbox.sliderShow(newId);

                            } else if (view.privateVars.lightboxTouch.lightboxTouchDiff > 40) {
                                view.privateVars.lightboxAnim = 1;

                                const newId = (view.privateVars.currentGalleryLightboxImage < view.privateVars.currentGalleryLightboxImages.count)
                                    ? (view.privateVars.currentGalleryLightboxImage + 1) : 1;

                                view.methods.lightbox.sliderShow(newId);
                            } else {

                                view.privateVars.lightboxTouch.lightboxTouchDiff = 0;
                                view.privateVars.lightboxTouch.lightboxTouchStart = 0;

                                view.privateVars.lightboxTouch.lightboxTouchDiffY = 0;
                                view.privateVars.lightboxTouch.lightboxTouchStartY = 0;

                                view.privateVars.lightboxTouch.lightboxSlideStarted = false;
                                view.privateVars.lightboxTouch.lightboxEndTrans = false;
                            }
                        } else {

                            view.privateVars.lightboxTouch.lightboxSlideStarted = false;
                            view.privateVars.lightboxTouch.lightboxEndTrans = false;
                        }
                    },
                },


                setCallbacks: (callbacks) => {
                    view.privateVars.callbacks = callbacks;
                }
            };

            /* custom events */

            pubSub.subscribe('view/actionShowGallery', view.methods.details.actionShowGallery);
            pubSub.subscribe('view/actionGetLightboxItems', view.methods.lightbox.actionGetLightboxItems);
            //pubSub.subscribe('view/updateSuccessLikes', view.methods.updateSuccessLikes);
            //pubSub.subscribe('view/updateSuccessViews', view.methods.updateSuccessViews);

            /* public methods */
            return {
                init: function (options, callbacks) {
                    view.methods.setCallbacks(callbacks);
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();


        return module;

    });